import { render, staticRenderFns } from "./UserCouponInfoStatDrawer.vue?vue&type=template&id=104fbb9a&scoped=true"
import script from "./UserCouponInfoStatDrawer.vue?vue&type=script&lang=js"
export * from "./UserCouponInfoStatDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserCouponInfoStatDrawer.vue?vue&type=style&index=0&id=104fbb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104fbb9a",
  null
  
)

export default component.exports